export default "__VITE_ASSET__BsnAkbnA__"